import React, {useState,useEffect} from 'react';
import styled from 'styled-components';
import {ClipLoader} from 'react-spinners';
import {MdClose} from 'react-icons/md';
import {
  Container,
  Row,
  Col,
  Label,
  Input,
  FormGroup
} from 'reactstrap';
import DxCompany from '../../stacks/company/DxCompanyAWS';


const SelectNAICSModal = props => {
  const {select,close,acceptableNaics} = props;
  const [searchTerm,setSearchTerm] = useState('');
  const [naicsData,setNaicsData] = useState(null);
  const [loading,setLoading] = useState(false);


  useEffect(() => {

    async function fetchNAICS() {
      try {
        setLoading(true);
        // console.info(`INFO searchTerm ${searchTerm}`)
        const naicsApi = DxCompany.getInstance()

        const data = await naicsApi.retrieveNaicsCodes(searchTerm)
        // console.info(`INFO fetchNAICS ${JSON.stringify(data, null, 2)}`)

        //
        // Gather titles and descriptions
        const descriptions = {}
        const titles = {}
        data.forEach((item) => {
          if (item.description && item.description.length !== 0) {
            descriptions[String(item.code)] = item.description
            titles[item.title] = item.description
          }
        })

        const ok = data.filter((value) => {
          value.acceptable = true
          if (acceptableNaics[String(value.code)] === undefined) {
            value.acceptable = false
            return false
          }
          let description = value.description
          value.copiedDescription = false
          if (description === undefined || description.length === 0) {
            description = titles[value.title]
            value.copiedDescription = true
          }
          if (value.description && value.description[0] && value.description[0].startsWith("See industry description for")) {
            const parts = value.description[0].split(' ')
            let code = parts[4]
            const period = code.indexOf('.')
            if (period !== -1) {
              code = code.substring(0, period)
            }
            code = code.trim()
            description = descriptions[code]
          }
          if (description === undefined || description.length === 0) {
            let code = value.code.toString()
            description = descriptions[code.substring(0,3)]
            if (description === undefined) {
              description = descriptions[code.substring(0,2)]  
            }
          }
          value.fullDescription = description
          return true
        })
        setNaicsData(ok);
        setLoading(false);
      }
      catch(err) {
        setLoading(false)
        console.log(err.message)
      }
    }

    searchTerm && searchTerm.length > 1 && fetchNAICS();
  },[searchTerm, acceptableNaics]);

  function handleSelect(code) {
    select(code);
    close()
  }

  const mainMenu = [
    (<ListItem key="11" onClick={() => {setSearchTerm("11")}}><strong>11</strong> - Agriculture, Forestry, Fishing and Hunting</ListItem>),
    (<ListItem key="21" onClick={() => {setSearchTerm("21")}}><strong>21</strong> - Mining</ListItem>),
    (<ListItem key="22" onClick={() => {setSearchTerm("22")}}><strong>22</strong> - Utilities</ListItem>),
    (<ListItem key="23" onClick={() => {setSearchTerm("23")}}><strong>23</strong> - Construction</ListItem>),
    (<ListItem key="31" onClick={() => {setSearchTerm("31")}}><strong>31</strong> - Manufacturing: food, tabacco, textile, sawmills </ListItem>),
    (<ListItem key="32" onClick={() => {setSearchTerm("32")}}><strong>32</strong> - Manufacturing: printing, wood, petroleum, coal, chemical base</ListItem>),
    (<ListItem key="33" onClick={() => {setSearchTerm("33")}}><strong>33</strong> - Manufacturing: metal based</ListItem>),
    (<ListItem key="42" onClick={() => {setSearchTerm("42")}}><strong>42</strong> - Wholesale Trade</ListItem>),
    (<ListItem key="44" onClick={() => {setSearchTerm("44")}}><strong>44</strong> - Retail</ListItem>),
    (<ListItem key="45" onClick={() => {setSearchTerm("45")}}><strong>45</strong> - Retail</ListItem>),
    (<ListItem key="48" onClick={() => {setSearchTerm("48")}}><strong>48</strong> - Transportation and Warehousing</ListItem>),
    (<ListItem key="49" onClick={() => {setSearchTerm("49")}}><strong>49</strong> - Transportation and Warehousing</ListItem>),
    (<ListItem key="51" onClick={() => {setSearchTerm("51")}}><strong>51</strong> - Information</ListItem>),
    (<ListItem key="52" onClick={() => {setSearchTerm("52")}}><strong>52</strong> - Finance and Insurance</ListItem>),
    (<ListItem key="53" onClick={() => {setSearchTerm("53")}}><strong>53</strong> - Real Estate Rental and Leasing</ListItem>),
    (<ListItem key="54" onClick={() => {setSearchTerm("54")}}><strong>54</strong> - Professional, Scientific, and Technical Services</ListItem>),
    (<ListItem key="56" onClick={() => {setSearchTerm("56")}}><strong>56</strong> - Administrative and Support and Waste Management and Remediation Services</ListItem>),
    (<ListItem key="62" onClick={() => {setSearchTerm("62")}}><strong>62</strong> - Health Care and Social Assistance</ListItem>),
    (<ListItem key="71" onClick={() => {setSearchTerm("71")}}><strong>71</strong> - Arts, Entertainment, and Recreation</ListItem>),
    (<ListItem key="72" onClick={() => {setSearchTerm("72")}}><strong>72</strong> - Accommodation and Food Services</ListItem>),
    (<ListItem key="81" onClick={() => {setSearchTerm("81")}}><strong>81</strong> - Other Services (except Public Administration)</ListItem>),
  ]

  return (
    <Overlay>
      <Container>
        <Row>
          <Col>
            <Modal>
              <FormGroup>
                <Label>Select sector or type keyword or phrase; then select item</Label>
                <Input
                  type="text"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </FormGroup>
              {!searchTerm && mainMenu}
              {searchTerm && (
                <div>
                  <div style={{textAlign:'center'}}>
                    <ClipLoader
                      color='blue'
                      loading={loading}
                    />
                    {naicsData && naicsData.length === 0 && <p>No results</p>}
                  </div>
                  <ListItem key="0" onClick={() => {setSearchTerm("")}}><strong>Clear selection</strong></ListItem>
                  {naicsData && naicsData.map(({code,title,fullDescription,acceptable,copiedDescription}) => (
                    <ListItem key={code} onClick={() => handleSelect(code)}>
                      <b>{`${code} - `}</b>
                      <span style={{fontStyle: 'italic'}}> {fullDescription} </span>
                    </ListItem>
                  ))}
                </div>
              )}
              <CloseModal onClick={close}/>
            </Modal>
          </Col>
        </Row>
      </Container>
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  background: rgba(0,0,0,0.5);
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding-top: 40px;
  z-index: 5000;
`;

const ListItem = styled.div`
  margin-bottom: 5px;
  cursor: pointer;

  :hover {
    background: rgba(35, 182, 234,0.3);
  }
`;

const Modal = styled.div`
  border-radius: 8px;
  padding: 40px;
  background: #fff;
  min-height: 200px;
  max-height: 90vh;
  box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.3);
  overflow: auto;
  position: relative;
`;

const CloseModal = styled(MdClose)`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export default SelectNAICSModal;
